module.exports = __webpack_public_path__ + "img/zhidaochuangyu.b5eacc0f.png";